import { render } from 'storyblok-rich-text-react-renderer';

function SchanktechnikContent({ document, document2, document3, document4, document5, blok }) {
     document = blok.richtext 
     document2 = blok.richtext2
     document3 = blok.richtext3
     document4 = blok.richtext4
     document5 = blok.richtext5
    // in the form { type: "doc", content: [ ... ] }
    return (
        <div className='wrap'>
    <div className='schanktechnikcontent-wrap inner-wrap'>
    <div className='schanktechnikcontent-left'>
        <h2 className='text-3xl'>{blok.subheadline}</h2>
        <div>{render(document)}</div>
        <div className='mt-3'>{render(document2)}</div>
        <div className='mt-3'>{render(document3)}</div>
        <div className='mt-3'>{render(document4)}</div>
        <div className='mt-3'>{render(document5)}</div>
    </div>
    <div className='schanktechnikcontent-right'>
        <img src={blok.image1.filename} alt={blok.image1.alt} />
        <img src={blok.image2.filename} alt={blok.image2.alt} />

    </div>
    </div>
    </div>
    );
}
export default SchanktechnikContent;